/****** Traçar Rota **********************************************/
		var directionDisplay;
		var directionsService = new google.maps.DirectionsService();
		var route = false;
		var map;
		var marker;
		var geocoder;
		
		function initialize() {
                    var posicao = {lat: -21.8607614, lng: -47.48733};
                        map = new google.maps.Map(document.getElementById('map'), {
                          center: posicao,
                              scrollwheel: false,
                          zoom: 17,
                        });

                         map.data.addGeoJson(local);
                        var local = {type: 'Duane Multimarcas',
                        features: [{
                          type: 'Feature',
                          geometry: {type: 'Point', coordinates: [-21.8607614, -47.48733]},
                          properties: {name: 'Duane'}
                        }]}
                          map.data.setStyle(function(feature) {
                          return {
                            title: feature.getProperty('name'),
                            optimized: false
                          };
                        });
                        var image = 'assets/images/duaneMark.png';
                        var marker = new google.maps.Marker({
                          position: posicao,
                          map: map,
                          title: 'Duane Multimarcas',
                              icon: image
                        });
                        var stylesArray = [
                        {
                          "featureType": "road.local",
                          "elementType": "geometry",
                          "stylers": [
                            { "visibility": "on" },
                            { "saturation": 74 },
                            { "color": "#ffffff" }
                          ]
                        },{
                          "featureType": "road",
                          "elementType": "labels.text.fill",
                          "stylers": [
                            { "color": "#89c34b" }
                          ]}];

                              map.setOptions({styles: stylesArray});
			directionsDisplay = new google.maps.DirectionsRenderer();
			geocoder = new google.maps.Geocoder();
			myLatlng = new google.maps.LatLng(-21.8607614, -47.48733);
			var myOptions = {
				zoom: 15,
				center: myLatlng,
				mapTypeControl: true,
				mapTypeId: google.maps.MapTypeId.ROADMAP
				
		  }
		
		  
		  directionsDisplay.setMap(map);
		  directionsDisplay.setPanel(document.getElementById("directionsPanel"));
		}
		
		function calcRoute() {
			if (marker) marker.setMap(null);
			route = true;
			var start = document.getElementById("inicioRota").value;
			var end = myLatlng;
			var request = {
			   origin:start, 
			   destination:end,
			   travelMode: google.maps.DirectionsTravelMode.DRIVING
			};
		
			directionsService.route(request, function(response, status) {
			 if (status == google.maps.DirectionsStatus.OK) {
			   directionsDisplay.setDirections(response);
			 }
		   });
		}
/*var map;
function initMap() {
  var posicao = {lat: -21.8607614, lng: -47.48733};
  map = new google.maps.Map(document.getElementById('map'), {
    center: posicao,
	scrollwheel: false,
    zoom: 17,
  });
  
   map.data.addGeoJson(local);
  var local = {type: 'Duane Multimarcas',
  features: [{
    type: 'Feature',
    geometry: {type: 'Point', coordinates: [-21.8607614, -47.48733]},
    properties: {name: 'Duane'}
  }]}
    map.data.setStyle(function(feature) {
    return {
      title: feature.getProperty('name'),
      optimized: false
    };
  });
  var image = 'assets/images/duaneMark.png';
  var marker = new google.maps.Marker({
    position: posicao,
    map: map,
    title: 'Duane Multimarcas',
	icon: image
  });
  var stylesArray = [
  {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [
      { "visibility": "on" },
      { "saturation": 74 },
      { "color": "#ffffff" }
    ]
  },{
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [
      { "color": "#89c34b" }
    ]}];
	
	map.setOptions({styles: stylesArray});
}*/
